/**
 * 列表 组件
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 *
 * 开放接口
 * handleFetch => fun(
 *     @页码，默认1;
 *    @flagUseLastSearch是否使用已用搜索条件,此配置不含前置条件不,默认false;
 *    @params 查询参数：选填，flagUseLastSearch为false可设置值，默认空;
 * )  => {}
 *
 * 必传参数
 * renderList           渲染列表
 *
 * 可选传参数：
 * searchFormOptions    搜索表格配置项，配置则显示搜索项
 * initFetch            进入是否查询 默认为true
 *
 * precondition     搜索前置条件
 * specialHandle    特别处理(查询前处理)
 *
 */
import React,{PureComponent,Fragment} from 'react';
import {Pagination, Spin,message,Tooltip,Space,Radio, Table} from "antd";
import Lang from "@components/Lang/Lang";
import {isEmpty,trim, toFixed2,formatNumberToPrice,symbolMoneyUtil,getWeek} from '@utils/utils';
import SearchForm from '@components/SearchForm/SearchForm';
import CustomerListService from "../CustomerList.action";
import AuthBtn from "@components/HoverIcon/AuthBtn";
// import UserScore from "../components/UserScore"
import SeniorFilter from "./SeniorFilter"
// import dayjs from 'dayjs';
import PropTypes from "prop-types";
import {lock} from "../../../../api/common/lock";
import CommonSelect from "@components//FormFormat/CommonSelect";
import FollowBtn from "@components/FollowUp/FollowBtn";
import "./List.less";
const Locale = require("../../../../utils/locale").default;
const localeLang = Locale.current();
const RadioGroup = Radio.Group;

export default class List extends PureComponent{
    static propTypes = {
        searchFormOptions: PropTypes.array,
        initFetch: PropTypes.bool,
        precondition: PropTypes.object,
        flagShowSearchBtn: PropTypes.bool,
    }
    static defaultProps = {
        searchFormOptions: [],
        initFetch: true,
        paginationFlag: true,
        precondition:{},
        labelType:"1010",//	1010:新客标签 1020:成交客户标签
    };
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            list:[],
            pageSize:50,
            pageIndex: 1,
            total: 0,
            orderByType:"",//"10",//默认按注册时间,
            isKaBuyer:"-1",
        }
    }
    /**
     * 搜索
     ***/
    getFormData(values={}) {
        const {searchFromDataSenior={}} = this.state;
        this.fetch(1,{...searchFromDataSenior,...values});
        this.setState({
            searchFromData:values
        })
    }
    /**
     * 高级搜索
     ***/
    setSeniorFormData(values={}) {
        this.setState({
            searchFromDataSenior:values
        })
    }
    /**
     * 重置
     **/
    searchReset(lastSearchCondition){
        this.fetch(1,lastSearchCondition);
    }
    changeKa(ka){
        this.loading(true);
        this.setState({
            isKaBuyer:ka,
        },()=>{
            this.fetch(1,this.state.lastSearchCondition);
        })
    }


    getOption(){
        const {allTabs=false,fxUserId,labelType} = this.props;
        return {
            // cnTitle: '操作',
            // cnTitleId: 'CaoZuo',
            title: Lang({id: "CaoZuo", default: "操作"}),
            dataIndex: 'CaoZuo',
            width: 220,
            fixed:"right",
            render: (item = {}, row) => (
                <Space>
                    {/*完善资料 旧的跟进 | 分销商 账号不能 进入 */}
                    {isEmpty(fxUserId)&&<Fragment>
                        <FollowBtn row={row} labelType={labelType} refreshPage={()=>this.fetch(1,this.state.lastSearchCondition)}
                                   disable={!row.canOperation} />
                        <AuthBtn icon={"ri-verified-badge-line"} tips = {Lang(row.canOperation?{id:"WanShanZiLiao",default:"完善资料"}:{id:"ZanWuQuanXian",default:"暂无权限"})}
                                 className={row.canOperation?"blueIconTips":"btnDisabled"}
                                 onClick={row.canOperation?()=>this.lock(row.id, row.status === "out"?0:1):""} />
                    </Fragment>}
                    <AuthBtn icon={"ri-contacts-line"} tips = {Lang({id:"KeHuXinXi",default:"客户信息"})}
                             target={"_blank"}
                             linkTo={`/customer/detail?id=${row.id}`} />
                    {/*详情*/}
                    <AuthBtn icon={"ri-file-list-2-line"} tips = {Lang({id:"DingDan",default:"订单"})}
                             target={"_blank"}
                             linkTo={`/dataStatistics/po?id=${row.id}`}/>
                    {/* 积分管理   {allTabs&& }*/}
                   {/*<UserScore row={row}/>*/}

                </Space>
            )
        }
    }
    lock(id, type) {
        const data = {
            buyerId: id,
            expireTime: 3600,
        };
        lock(data)
            .then((response) => {
                if (response.data.success && response.data.valid) {
                    /*this.props.history.push(
                        `/customer/follow?id=${id}&follow=${type}`
                    );*/
                    window.open(`/customer/follow?id=${id}&follow=${type}`,'about:blank')

                } else {
                    message.info(
                        Lang({
                            id: "YouYeWuYuanZhengZaiGenJin",
                            default: "有业务员正在跟进，请勿重复操作",
                        })
                    );
                }
            })
            .catch((error) => {
                message.error(error.message);
            });
    }
    /**
     * 搜索
     * @param pageIndex 页码
     * @param fetchCondition 条件
     */
    fetch(pageIndex=1,fetchCondition={}){
        this.loading(true);
        const { precondition,labelType} = this.props;
        const { pageSize,orderByType,isKaBuyer} = this.state;
        // 处理 空值
        let newSearchMap = {...precondition,...fetchCondition};
        for(let key in newSearchMap){
            if(isEmpty(newSearchMap[key])) delete newSearchMap[key];
        }
        if(!isEmpty(orderByType)){
            newSearchMap["orderByType"]=orderByType
        }
        //   labelType={"1020"}//1010:新客标签 1020:成交客户标签
        if(labelType=="1020"&&isKaBuyer!="-1"){
            newSearchMap["isKaBuyer"]=isKaBuyer;
        }
        CustomerListService.fetch('/service/mg/follower/list',pageSize, pageIndex,newSearchMap).then((resp)=>this.handleRes(resp.data,pageIndex,fetchCondition)).catch(err=>this.handleErr(err));
    }
    loading(flag){
        this.setState({
            loading:flag
        })
    }
    handleRes(res={},pageIndex=1,fetchCondition={}){
        this.loading(false);
        const {success,valid,models,paging} = res;
        if (success && valid) {
            if(this.props.fetchCallBack){
                this.props.fetchCallBack(res);
            }
            const resList = models || [];
            $(document).scrollTop(0);
            this.setState({
                list: resList,
                total: paging.total,
                pageIndex:pageIndex,
                lastSearchCondition:fetchCondition
            })
        }else {
            this.resetList();
            if(res.message)message.error(res.message);
        }
    }
    resetList(){
        this.setState({
            list: [],
            total: 0,
            pageIndex:1,
        })
    }
    handleErr(err){
        this.loading(false);
    }
    /**
     * 切换页码
     * **/
    onChangePage(page,currPageSize){
        const { pageSize } = this.state;
        if(currPageSize!=pageSize){
            this.setState({
                pageSize:currPageSize
            },()=>this.fetch(page,this.state.lastSearchCondition))
        }else this.fetch(page,this.state.lastSearchCondition);
    }
    onRefSearch = (ref) =>  this.onRefSearchChrld = ref;
    onChangeSort(item){
        this.setState({
            orderByType:item
        },()=>{
            this.fetch(1,this.state.lastSearchCondition);
        })
    }
    /**
     * 外部调用接口
     * @flag true 重置查询表单条件
     */
    reRefreshSearch(flag=true){
        if(flag){
            this.setState({
                loadingSearchFilterObj:true,
                orderByType:"",//"10",////默认按注册时间
            },()=>{
                this.setState({
                    loadingSearchFilterObj:false,
                })
                this.fetch(1)
            })
        }else{
            const { pageIndex=1, lastSearchCondition={}} = this.state;
            this.fetch(pageIndex,lastSearchCondition)
        }
    }
    componentWillMount() {
        const dList =__getDictList("is_ka_buyer")||[];
        let options= [
            { label:Lang({id:"QuanBu",default:"全部"}), value: '-1',  },
            // { label:Lang({id:"QuanBu",default:"KA客户"}), value: '1',  },
            // { label:Lang({id:"QuanBu",default:"非KA客户"}), value: '0',  },
        ]
        dList.forEach(item=>options.push({label:item.name,value:item.code+""}));
        this.setState({
            optionsKa: options
        })
    }
    componentDidMount() {
        if(this.props.onRef){
            this.props.onRef(this);
        }
        if(this.props.initFetch){
            this.fetch(1);
        }
    }
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }
    render(){
        const { searchFormOptions,flagShowSearchBtn,columns,precondition,allTabs=false, labelType=""} = this.props;
        const { list, loading,pageIndex,pageSize,total,orderByType,loadingSearchFilterObj=false,searchFromData={},optionsKa=[],isKaBuyer=""} = this.state;
        return ( <Spin spinning={loading}>
            <div className={'autoFetchList'}>
                {!loadingSearchFilterObj&&searchFormOptions.length>0&&<div className={'top-search'}>
                    <SearchForm
                        onRef={this.onRefSearch}
                        options = {searchFormOptions}
                        initialValues={precondition}
                        searchReset={(dat)=>this.searchReset(dat)}
                        flagShowReset={false}
                        flagShowSearchBtn={flagShowSearchBtn}
                        searchLeft={labelType=="1020"?<RadioGroup className={"mr_8"} options={optionsKa}
                                                                  onChange={(e)=>this.changeKa(e.target.value)} value={isKaBuyer} optionType="button" />:null}//1010:新客标签 1020:成交客户标签
                        setLeftBtnRight={<SeniorFilter search={(data=>{
                                                                    this.setSeniorFormData(data);
                                                                    this.fetch(1,{...searchFromData,...data})
                                                    })}
                                                    labelType={labelType}
                                                    isAllTab={allTabs}
                                                    searchReset={(dat)=>{
                                                        this.setSeniorFormData({});
                                                        this.searchReset(searchFromData)}
                                                    } />}
                        setRight={labelType=="1010"?<CommonSelect placeholder={Lang({id: "PaiXuFangShi", default: "排序方式"})}
                                                                  width={localeLang=="ru"?"400":(localeLang=="zh"?"120":"200")}
                                                // allowClear={false}
                                                initValue={orderByType}
                                                onChange={(data)=>this.onChangeSort(data)}
                                                list={[
                                                    {
                                                        id: "10",
                                                        name: Lang({id: "AnZhuCeShiJian", default: "按注册时间"}),
                                                    },
                                                    // {
                                                    //     id: "20",
                                                    //     name: Lang({id: "AnFangWenShiJian", default: "按访问时间"}),
                                                    // },
                                                    {
                                                        id: "30",
                                                        name: Lang({id: "AnJiaGouShiJian", default: "按加购时间"}),
                                                    },
                                                    {
                                                        id: "40",
                                                        name: Lang({id: "AnGenJinShiJian", default: "按跟进时间"}),
                                                    },
                                                ]}
                        />:null}
                        getSearchValue={this.getFormData.bind(this)} />
                </div>}
                <Table columns={ [...columns, this.getOption()] }
                       pagination={false}
                       dataSource={list}  // 数据源
                       rowKey={record =>record.id}    // KEY
                       scroll={{ x: 1300 }}
                />
                    {list.length >0?<div className="margin-top-20 text-center"> {/*分页*/}
                    <Pagination total={total}
                        defaultPageSize={pageSize}
                        current={pageIndex}
                        showQuickJumper
                        onChange={this.onChangePage.bind(this)} />
                </div>:null}
            </div>
        </Spin> )
    }
}

